// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'select2';


export default class SelectDesignAutoSelection extends WebComponent {
	didMount () {
		let element = this.element;
		$(element).select2({
			minimumResultsForSearch: Infinity
		}).on('change', function(e) {
			if(element.getAttribute('data-auto-submit') === 'true') {
				let formElement = element.closest('form');
				let submitElement = formElement.querySelector('button[type="submit"]');
				submitElement.click();
			}
		});
		if(this.element.options.length === 2 && this.element.options.selectedIndex === 0) {
			$(element).val(this.element.options[1].value).trigger('change',false);
		}
	}
}




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/SelectDesignAutoSelection.js